import messages from '../locales/lv_LV.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'lv-LV',
};
export default lang;
